import React from 'react'

const FirefoxButton = function(props) {
  return (
    <a href="/ff_signin?s=pocket&t=login" className="btn btn-secondary login-btn-firefox">
      <span className="logo"></span>
      <span className="text">{ props.children }</span>
    </a>
  )
}

export { FirefoxButton }



// WEBPACK FOOTER //
// ./client/Components/FirefoxButton/FirefoxButton.jsx